import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getPerformance } from "firebase/performance";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { getRemoteConfig } from "firebase/remote-config";

import {
  FIRESTORE_API_KEY,
  FIRESTORE_AUTH_DOMAIN,
  FIRESTORE_PROJECT_ID,
  FIRESTORE_STORAGE_BUCKET,
  FIRESTORE_MESSAGING_SENDER_ID,
  FIRESTORE_APP_ID,
  FIRESTORE_MEASUREMENT_ID,
} from "@env";

const firebaseConfig = {
  apiKey: FIRESTORE_API_KEY,
  authDomain: FIRESTORE_AUTH_DOMAIN,
  projectId: FIRESTORE_PROJECT_ID,
  storageBucket: FIRESTORE_STORAGE_BUCKET,
  messagingSenderId: FIRESTORE_MESSAGING_SENDER_ID,
  appId: FIRESTORE_APP_ID,
  measurementId: String(FIRESTORE_MEASUREMENT_ID),
};

//TEST FIREBASE. DO NOT USE FOR PRODUCTION!!!
// const firebaseConfigTest = {
//   apiKey: "AIzaSyDjNLpFALtU5DbmatFQHgxaplZFfEBWocc",
//   authDomain: "test-app-55e64.firebaseapp.com",
//   projectId: "test-app-55e64",
//   storageBucket: "test-app-55e64.appspot.com",
//   messagingSenderId: "524315672415",
//   appId: "1:524315672415:web:e7c62cb2a339a72b2700ea",
//   measurementId: "G-24CXZC7C9B",
// };

export const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
export const auth = getAuth(app);

const isDevEnv =
  process.env.NODE_ENV === "development" ||
  (typeof window !== "undefined" && window.location.hostname === "localhost");

// Firebase Remote Config (web)
// Used for safe rollouts / feature flags.
export const remoteConfig = (() => {
  try {
    const rc = getRemoteConfig(app);
    rc.settings = {
      fetchTimeoutMillis: 5000,
      minimumFetchIntervalMillis: isDevEnv ? 5000 : 60 * 60 * 1000,
    };
    rc.defaultConfig = {
      // Feature flag for NetworkManager authoritative time
      use_server_time: true,
    };
    return rc;
  } catch (e) {
    return null;
  }
})();

// Only connect to the emulator in development
// if (process.env.NODE_ENV === "development") {
//   connectFirestoreEmulator(db, "localhost", 8080);
// }
// if (process.env.NODE_ENV === "development") {
//   const functions = getFunctions(app);

//   connectFunctionsEmulator(functions, "localhost", 5001);
// }
// export const analytics = getAnalytics(app);
const performance = getPerformance(app);
// const storage = getStorage(app);
export const storage = getStorage(app);

export default db;
